import TopBar from "../../_common/topbar/TopBar";
import Vegas from "../../_common/Vegas/Vegas";
import {
  details,
  minical,
  room1_img,
  room_img,
  children_img,
  adult_new,
  adults,
  Loader,
  add_rooms,
  click_img,
  roman1,
  roman2,
  delete_img,
  add_shopping_cart,
  account_circle,
  pop_up_arrow,
  phone_in_talk,
  mail,
} from "../../../assets/images";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import useStandard from "./useStandard";
import "./Standard.css";
import { useLocation } from "react-router";
import { commaValidation } from "../../../utility";
import { withTranslation } from "react-i18next";
import { useEffect } from "react";

const Standerd = (props) => {
  const { t } = props;

  const location = useLocation();
  var costData = 0;
  let RoomCount = 0;
  const {
    newArr,
    adult,
    extra,
    diffDate,
    children,
    service,
    rooms,
    roomData,
    totalGstCharge,
    totalPayableAmount,
    showShipping,
    pathimg,
    datetimevalue,
    datetimevalue1,
    loader,
    checkindate,
    totalRoomCharge,
    checkoutdate,
    extradata,
    taxdata,
    adultcount,
    datafinalvalue,
    datafinaltax,
    singleRoomInfo,
    roomAmount,
    fullName,
    mobile_no,
    email,
    startEndDate,
    startEndDateRange,
    tableCalculation,
    childrenCount,
    handleChange,
    handleChangeChildren,
    handleAdd,
    addToCart,
    isInCategory,
    checkPrice,
    closeShipping,
    onChangeValue,
    openShipping,
    selectPath,
    continuToBook,
    onChangeValue1,
    handleChildAgeChange,
    handleChangeinc,
    handleChangedec,
    handleChangechildinc,
    handleChangechilddec,
    roomAdded,
    handleChangeRoominc,
    handleChangeRoomddec,
    handleDelete,
    handlePopup,
    user_id,
    showPopup,
    childrenAges,
    request,
    handleChangeRequest,
    sendSpecialRequest,
  } = useStandard(location, t);
  // const {

  // } = useBookingDetails( location);
  {
    RoomCount =
      Number(location?.state?.roomsavailable) - Number(adultcount.length);
  }
  /**
   *
   * @returns render top bar
   */

  const renderTopBar = () => {
    return <TopBar />;
  };
  /**
   * render vegas bar
   * @returns
   */
  const renderVegasBar = () => {
    return <Vegas />;
  };

  /**
   * render shipping details
   * @returns
   */
  const Shipping = () => {
    return (
      <div className="modalPop" id="shippingModal">
        <div className="modal-dialog modal-md modal-dailog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" onClick={closeShipping}>
                &times;
              </button>
            </div>

            <div className="modal-body">
              <Carousel showDots={false} autoPlay infinite={true}>
                {roomData &&
                  roomData?.[0] &&
                  roomData?.[0]?.room_image.map((list) => (
                    <div>
                      <img
                        src={`${process.env.REACT_APP_MEDIA_DOMAIN}${list}`}
                        alt="no_image"
                      />
                    </div>
                  ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const Tooltip2 = ({ text, children }) => (
    <div className="tooltip-container">
      {children}
      <span className="tooltip-text">
        <ol>
          <li className="tooltip-item">
            Cancellations made 24 hours prior to check-in time (2:00 PM) will be
            refundable, with a deduction of 5% as a payment processing charge on
            the gross room rate (before tax amount). This policy is not
            applicable post check-in.
          </li>
          <li className="tooltip-item">
            In case of no-shows, the amount will be non-refundable and incur
            100% charges.
          </li>
          <li className="tooltip-item">
            Last-minute cancellations, i.e., 0 to 24 hours from the check-in
            time, will be partially refundable with a deduction of 20% on the
            gross room rate (before tax amount).
          </li>
          <li className="tooltip-item">
            In case of a reduction of room nights post check-in, a partial
            refund will be applicable with a deduction of 50% on the gross room
            rate (before tax amount).
          </li>
        </ol>
      </span>
    </div>
  );

  const Tooltip1 = ({ text, children }) => (
    <div className="tooltip-container fggggdfgdfgg">
      {children}
      <span className="tooltip-text">
        <ol>
          <li className="tooltip-item">
            Primary guest should be atleast 18 years of age.
          </li>
          <li className="tooltip-item">
            Passport, Aadhar, Driving License and Govt. ID are accepted as ID
            proof(s).
          </li>
          <li className="tooltip-item">Pets are not allowed.</li>
          <li className="tooltip-item">Couple Friendly.</li>
        </ol>
      </span>
    </div>
  );
  /**
   * render room images
   * @returns
   */

  const renderRoomImages = () => {
    return (
      <>
        {roomData &&
          roomData.map((datas) => (
            <div className="main_view flt">
              <div className="right_view_room">
                <img
                  src={
                    pathimg
                      ? `${process.env.REACT_APP_MEDIA_DOMAIN}${pathimg}`
                      : datas?.room_image?.[0]
                      ? `${process.env.REACT_APP_MEDIA_DOMAIN}${datas?.room_image?.[0]}`
                      : room1_img
                  }
                  alt="no_image"
                />
              </div>
              <ul className="left_view_room ">
                {datas?.room_image
                  .filter((item, index) => index < 5)
                  .map((imgdata) => (
                    <li onClick={() => selectPath(imgdata)}>
                      <img
                        src={`${process.env.REACT_APP_MEDIA_DOMAIN}${imgdata}`}
                        alt="no_image"
                      />
                      {/* {roomData?.[0]?.room_image?.length >= 4 ? "" :
                      <span onClick={openShipping}>
                        +{roomData?.[0]?.room_image?.length}
                      </span>} */}
                      {roomData?.[0]?.room_image?.length >= 4 ? (
                        <span onClick={openShipping}>
                          +
                          {Number(roomData?.[0]?.room_image?.length) -
                            Number(5)}
                        </span>
                      ) : (
                        ""
                      )}
                    </li>
                  ))}
              </ul>
            </div>
          ))}
      </>
    );
  };
  /**
   * render room description
   * @returns
   */
  const renderRoomDescription = () => {
    return (
      <div className="main_row_pad flt">
        <div className="row">
          <div className="col-sm-12">
            <ul className="standard_amenities flt">
              {roomData &&
                roomData?.[0]?.amenities.map((res) => (
                  <li>
                    <img
                      src={`${process.env.REACT_APP_MEDIA_DOMAIN}${res?.amenities_image}`}
                      alt="no_image"
                    />
                    <span>{res?.amenities}</span>
                  </li>
                ))}
            </ul>
          </div>
          <div className="col-sm-12">
            <div className="main_description flt">
              <div className="room_description flt">
                {t("Room_Description")}
              </div>

              <div className="description">{roomData?.[0]?.description}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  /**
   * render selecting room details
   * @returns
   */
  const selectedRoom = () => {
    return <div className="main_view_room flt"></div>;
  };

  /**
   * display checkin and checkout details
   * @returns
   */
  const checkinCheckoutDetails = () => {
    return (
      <div className="main_cal_pad flt">
        <div className="row">
          <div className="col-sm-6">
            <div className="che_pad flt">
              <div className="main_che_pad flt">
                <div className="main_cla ">
                  <div className="main_cal_image flt">
                    {/* <div className="main_imgcal"> </div> */}
                    <img src={minical} alt="no_image" />

                    <Datetime
                      name="checkin"
                      dateFormat="DD/MM/YYYY"
                      onChange={onChangeValue}
                      value={new Date(datetimevalue)}
                      closeOnSelect={true}
                      timeFormat={true}
                      isValidDate={(currentDate, selectedDate) =>
                        currentDate.isAfter(
                          new Date().getTime() - 24 * 60 * 60 * 1000
                        )
                      }
                      inputProps={{
                        placeholder: "Check-In",
                        disabled: true,
                        readOnly: true,
                        onKeyDown: (e) => e.preventDefault(),
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="che_pad flt">
              <div className="main_che_pad flt">
                <div className="main_cla ">
                  <div className="main_cal_image flt">
                    <img src={minical} alt="no_image" />

                    <Datetime
                      dateFormat="DD/MM/YYYY"
                      name="checkout"
                      timeFormat={true}
                      onChange={onChangeValue1}
                      value={new Date(datetimevalue1)}
                      closeOnSelect={true}
                      isValidDate={(currentDate, selectedDate) =>
                        currentDate.isAfter(
                          new Date().getTime() - 24 * 60 * 60 * 1000
                        )
                      }
                      inputProps={{
                        placeholder: "Check-Out",
                        disabled: true,
                        readOnly: true,
                        onKeyDown: (e) => e.preventDefault(),
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  /**
   * gest room display
   * @returns
   */
  const guestRoom = () => {
    return (
      <div className="guest_pad flt">
        <div className="guest_flex flt">
          {/* <div className="addroom_btn flt">
            {adultcount.length > 0 && (
              <button class="add_to_cart_btn" onClick={() => addToCart()}>
                Add To Cart
              </button>
            )}
          </div> */}

          <div className="room_rate mobile_hide flt">
            <span>Price:</span>{" "}
            {totalRoomCharge
              ? `₹ ${commaValidation(Number(totalRoomCharge).toFixed(2))}`
              : `₹ ${commaValidation(
                  Number(singleRoomInfo[0]?.price).toFixed(2)
                )}`}
          </div>
        </div>
        {/* <div className="price_flex flt">
          Total available rooms :{" "}
          {Number(location?.state?.roomsavailable) - Number(adultcount.length)}
        </div> */}
        {/* <div className="add_rrom_main flt">
          <div className="add_room_txt">
            <img src={add_rooms} />
            Add Number of Rooms
          </div>
          <div
            className={
              Number(adultcount.length) == 1
                ? "addroom_btn opacityadd "
                : "addroom_btn "
            }
          >
            <button onClick={() => handleAdd()}>+ Add room</button>
          </div>
          
        </div> */}
        {/* <div className="warnn_txt flt">
          <img src={click_img} />
          Click on 'Add Room' above to select the number of rooms.
        </div> */}
        <div className="main_guest_adultsbb flt">
          {adultcount.map((data, i) => (
            <div>
              <div className="couuuntss flt">
                <div className="guest_adults flt">
                  <div className="main_adult_img">
                    <div className="roomCounttt">{i + 1}</div>
                    <div className="person_count">Room</div>
                    <div className="person_count">Adults</div>
                  </div>

                  <div className="main_increment">
                    <select
                      name="item"
                      value={adultcount}
                      onChange={(e) => handleChange(e, i)}
                    >
                      <option selected disabled>
                        Select adult count
                      </option>
                      {Array.from({ length: 2 }, (_, index) => (
                        <option key={index + 1} value={index + 1}>
                          {index + 1}
                        </option>
                      ))}
                      {/* <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option> */}
                    </select>

                    {/* <button className="room_remove" onClick={() => handleDelete(i)}>
                  <img src={delete_img} />
                </button> */}
                  </div>
                </div>

                {/* <button className="room_remove" onClick={() => handleDelete(i)}>
                  <img src={delete_img} />
                </button> */}
              </div>
              {Array.from({ length: childrenCount || 0 }, (_, childIndex) => (
                <select
                  key={childIndex}
                  className="child-dropdown"
                  value={childrenAges[childIndex] || ""}
                  onChange={(event) => handleChildAgeChange(childIndex, event)}
                >
                  <option selected disabled>
                    Select Child {childIndex + 1} Age
                  </option>
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                </select>
              ))}
            </div>
          ))}
        </div>

        <div className="extra_details flt">
          <ul>
            <li>
              <img src={roman1} /> Extra Adult Charge: ₹
              {roomData[0]?.extra_occupancy} + applicable taxes
            </li>
            <li>
              <img src={roman2} /> Extra Child Charge (8 years and above): ₹
              {roomData[0]?.extra_occupancy}+ applicable taxes
            </li>
            <li>
              <img src={roman2} /> Complimentary breakfast served with veg
              options
            </li>
          </ul>
        </div>

        {/* <div className="row"></div> */}

        {/* <div className="total_length flt">
          {t("Total_Length_of_stay")} :{" "}
          {commaValidation(
            diffDate && diffDate !== "0" ? Math.round(diffDate).toFixed(0) : "1"
          )}
        </div>

        <div className="total_length flt">Extra adult charge : ₹900 + tax</div>
        <div className="total_length flt">
          {" "}
          Extra Child (8 years and above) : ₹900 + tax
        </div>

        <div className="child_paxs">
          {" "}
          Complimentary breakfast served with veg options
        </div> */}

        <div className="table_container">
          <table className="table">
            <thead className="table-head">
              <tr className="table-row">
                <th className="table-header">Date</th>
                <th className="table-header">Room Price</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {tableCalculation[0]?.detail[0]?.adult_count
                ? Object.entries(
                    tableCalculation.slice(0, -1).reduce((acc, ele) => {
                      ele?.detail.forEach((detailItem) => {
                        const { date } = ele;
                        const amount = detailItem?.adult_count
                          ? detailItem?.roomCharge + detailItem?.gst
                          : 0;
                        acc[date] = acc[date] ? acc[date] + amount : amount;
                      });
                      return acc;
                    }, {})
                  ).map(([date, totalAmount], index) => (
                    <tr className="table-row" data-index={index} key={index}>
                      <td className="table-data">{date}</td>
                      <td className="table-data">
                        ₹ {commaValidation(Number(totalAmount).toFixed(2))}
                      </td>
                    </tr>
                  ))
                : singleRoomInfo?.slice(0, -1)?.map((ele, index) => (
                    <tr className="table-row" data-index={index} key={index}>
                      <td className="table-data">
                        {new Date(ele?.date).toLocaleDateString("en-GB")}
                      </td>
                      <td className="table-data">
                        ₹ {commaValidation(Number(ele?.price).toFixed(2))}
                      </td>
                    </tr>
                  ))}

              {/* {tableCalculation[0]?.detail[0]?.adult_count
                ? tableCalculation?.slice(0, -1)?.map((ele, index) => (
                    <tr className="table-row" data-index={index}>
                      <td className="table-data">{ele?.date}</td>
                      <td className="table-data">
                        ₹{" "}
                        {commaValidation(
                          Number(
                            ele?.detail[0]?.roomCharge + ele?.detail[0]?.gst
                          ).toFixed(2)
                        )}
                      </td>
                    </tr>
                  ))
                : singleRoomInfo?.slice(0, -1)?.map((ele, index) => (
                    <tr className="table-row" data-index={index}>
                      <td className="table-data">
                        {new Date(ele?.date).toLocaleDateString("en-GB")}
                      </td>
                      <td className="table-data">
                        ₹ {commaValidation(Number(ele?.price).toFixed(2))}
                        
                      </td>
                    </tr>
                  ))} */}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
  /**
   *
   * @returns this functionality is for adding extra service for a room
   */
  const exstraService = () => {
    return (
      <div className="main_services flt">
        {/* <div className="services">{t("Add_Extra_Services")}</div> */}
        {/* <div className="main_check">
          <ul>
            {service && service.map((data) =>
              <div className="check_box">
                <li>
                  <input
                    type="checkbox"
                    name="parking"
                    checked={isInCategory(data?.service_name)}
                    onChange={(e) => checkPrice(data?.service_name, data?.price, data?.people_choice, e, data?._id)}
                  />
                  <label>{data?.service_name}</label>
                </li>
                {(adult !== 0 || children !== 0) ?
                  <div className="parking_money">{data?.people_choice === true ? `₹ ${commaValidation((data?.price * (adult + children) * (diffDate === 0 ? 1 : diffDate)))}` : `₹ ${commaValidation(data?.price)}`}</div>
                  : <div className="parking_money">₹ {data?.people_choice === true ? commaValidation((data?.price) * (diffDate === 0 ? 1 : diffDate)) : commaValidation((data?.price))}</div>}
              </div>
            )}

          </ul>
        </div> */}

        {/* <hr className="line" /> */}

        {
          // <div
          //   className={`main_room_charge come_as_pop_up flt ${
          //     showPopup ? "slide_in" : "slide_out"
          //   }`}
          // >
          <div
            className="main_room_charge come_as_pop_up flt"
            style={{ display: !showPopup ? "block" : "none" }}
          >
            <div className="booking_pay_txt flt">
              Booking and Payment Details
            </div>
            <ul className="room_charge flt ">
              <li>
                <div className="charges2">Date</div>
                <div className="charges2 charges_bold">{startEndDateRange}</div>
              </li>
              <li>
                <div className="charges2">Total Length of stay </div>
                <div className="charges2 charges_bold">
                  {" "}
                  {commaValidation(
                    diffDate && diffDate !== "0"
                      ? Math.round(diffDate).toFixed(0)
                      : "1"
                  )}{" "}
                  Days
                </div>
              </li>
              <li>
                <div className="charges2">Total Room Charges </div>
                <div className="charges2 charges_bold">
                  ₹ {commaValidation(Number(totalRoomCharge).toFixed(2))}
                </div>
              </li>
              <li>
                <div className="charges2">Total Tax</div>
                <div className="charges2 charges_bold">
                  ₹ {commaValidation(Number(totalGstCharge).toFixed(2))}
                </div>
              </li>
              <li className="last_total">
                <div className="charges2">{t("Total_Payable_Amount")}</div>
                <div className="ammount_clr_no">
                  {" "}
                  ₹ {commaValidation(Number(totalPayableAmount).toFixed(2))}
                </div>
              </li>
              {/* <li>
              <div className="charges2">{t("Additional_Charges")}</div>
              <div className="charges2 charges_bold">₹ {commaValidation(extra)}</div>
            </li> */}
            </ul>
            {/* <hr className="line" /> */}
          </div>
        }

        {/* <div className="main_total_amt flt">
          <ul className="total_amt flt">
            <li>
              <div className="ammount_clr">{t("Total_Payable_Amount")}</div>
              <div className="ammount_clr_no">
                {" "}
                ₹ {commaValidation(Number(totalPayableAmount).toFixed(2))}
              </div>
            </li>
            <hr className="line1" />
          </ul>
        </div> */}

        {user_id && (
          <div className="account_details flt" style={{ marginBottom: "10px" }}>
            <div className="namee">
              <img src={account_circle} />
              {fullName}
            </div>
            <div className="details">
              <span>
                <img src={phone_in_talk} /> {mobile_no}
              </span>
              <span>
                <img src={mail} />
                {email}
              </span>
            </div>
          </div>
        )}
        <div className="special_request_container">
          <p className="special_request">Special Request</p>
          <div>
            <textarea
              placeholder="Enter any special Request"
              value={request}
              onChange={handleChangeRequest}
            ></textarea>
          </div>
        </div>
        <div
          className={
            adultcount.length == 0
              ? "continue_btn opacityadd flt"
              : "continue_btn flt"
          }
        >
          <div className="mob_pay_info desktop_hide flt">
            <div className="flt">
              <div className="pay_txtt flt">Total Payable Amount</div>
              <div className="pay_amtt">
                ₹ {commaValidation(Number(totalPayableAmount).toFixed(2))}
              </div>
            </div>
            <div className="pay_more_inffo flt" onClick={handlePopup}>
              Payment Details <img src={pop_up_arrow} />
            </div>
          </div>

          <div className="btnss_div flt">
            {/* <button className="add_booking_btn" onClick={() => addToCart()}>
              <span className="mobile_hide">
                <img src={add_shopping_cart} /> Add to Booking Cart
              </span>
              <span className="desktop_hide">
                <img src={add_shopping_cart} /> Add to Cart
              </span>
            </button> */}
            <button className="main_continue" onClick={continuToBook}>
              <span className="mobile_hide">{t("Continue_to_Book")}</span>
              <span className="desktop_hide">Book Now</span>
            </button>
          </div>
        </div>
      </div>
    );
  };
  /**
   * render checkin and checkout details
   * @returns
   */
  const renderCheckinCheckout = () => {
    return (
      <div className="col-sm-4">
        {/* <div className="main_det flt">
          <div className="main_checkin flt">
            <div className="checkin flt">
              <img src={details} alt="no_image" />
              <div className="checkout">
                {t("Check-in &_Check-out_Details")}
              </div>
            </div>
            {loader !== "loading" && checkinCheckoutDetails()}
          </div>
        </div> */}
        <>
          {loader === "loading" && (
            <div className="main_load ">
              <img src={Loader} alt="loader" />
            </div>
          )}
          {loader !== "loading" && (
            <div className=" flt">{exstraService()}</div>
          )}
        </>
      </div>
    );
  };
  /**
   * render room details
   * @returns
   */
  const renderRoomDetails = () => {
    return (
      <>
        {loader === "loading" && (
          <div className="main_load ">
            <img src={Loader} alt="loader" />
          </div>
        )}
        {loader !== "loading" && (
          <>
            <div className="col-sm-8 main_Standerd_room">
              <div className="hfjkasdfg">
                <div className="room_stnd flt">
                  {" "}
                  {roomData?.[0]?.room_type}{" "}
                </div>
                <div className="cancelationDetail flt">
                  <Tooltip2>
                    <p style={{ marginRight: "10px" }}>
                      Cancellation Policy Details
                    </p>
                  </Tooltip2>
                  <Tooltip1>
                    <p>Important Information</p>
                  </Tooltip1>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-6">
                  <div className=" flt">
                    {selectedRoom()}
                    <div className=" flt">
                      {renderRoomImages()}
                      {renderRoomDescription()}
                    </div>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="standard_middle flt">
                    <div className="main_discount flt">
                      <div className="main_room_rate flt">
                        <div className="addroom_block flt">{guestRoom()}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-sm-4">
             
            </div> */}
          </>
        )}
      </>
    );
  };

  return (
    <div className="main_container flt">
      {renderTopBar()}
      {/* {renderVegasBar()} */}
      <div className="main_row  flt">
        <div className="checkinDtaes flt mobile_hide">
          Check-In & Check-Out | {startEndDate}
        </div>
        <div className="row">
          {renderRoomDetails()}
          {renderCheckinCheckout()}
        </div>
      </div>

      {showShipping === true && Shipping()}
    </div>
  );
};
export default withTranslation()(Standerd);
